class RefundTransactionService {
  constructor(client) {
    this.apiClient = client;
  }

  async searchRefundTransactions(searchParams, cancelToken) {
    return await this.apiClient.post(
      `refundsearch/refundabletickets`,
      searchParams,
      {
        headers: { "Content-Type": "application/json" },
      },
      cancelToken
    );
  }
}

export default RefundTransactionService;
